import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2'
import { Link } from "react-router-dom";
import { SiGmail } from "react-icons/si";
import { FaPhone } from "react-icons/fa6";
import { IoLogoWhatsapp } from "react-icons/io";

const Contact = () => {
    const [service, setService] = useState('');
    const [subService, setSubService] = useState('');
    const [currency, setCurrency] = useState('USD');
    const [currentStep, setCurrentStep] = useState(1); // State to track form progress
    const [name, setName] = useState('');
    const [phone, setphone] = useState('');
    const [email, setEmail] = useState('');
    const [date, setDate] = useState(null);
    const [time, setTime] = useState(null);
    const [budget, setBudget] = useState('');
    const [projectDetails, setProjectDetails] = useState('');
    const [errorMessages, setErrorMessages] = useState({});
    
    // Data for sub-services based on selected service
    const subServicesData = {
      'Web development': [
        'Frontend Development',
        'Backend Development',
        'Full Stack Development',
        'Figma to Website',
        'Templates',
        'Website Customization',
        'Landing Page',
        'Dropshipping Website',
        'AI Website',
        'Web3 Website',
        'Shopify',
        'WordPress',
        'Squarespace',
        'Wix',
        'Webflow'
      ],
      'Application Development': [
        'Cross Platform Development',
        'Android App Development',
        'iOS App Development',
        'Website to App',
        'AI Mobile App',
        'API Integration'
      ],
      'Graphic Designing': [
        'Logo Design',
        'Business Cards',
        'NFT Art',
        'Figma Design',
        'Flyer Design',
        'Brochure Design',
        'Social Posts & Banners',
        'Web Banners',
        'Poster Design',
        'Catalog Design',
        'Menu Design'
      ],
      'Marketing': [
        'SEO',
        'Social Media Marketing',
        'Email Marketing',
        'TikTok Shop',
        'Facebook Ads Campaign',
        'Instagram Marketing',
        'Mobile App Marketing',
        'E-Commerce Marketing'
      ],
      'Other': []
    };    
    // Social media contact options
    const contactOptions = [
      { name: 'WhatsApp', ico:<IoLogoWhatsapp className='text-green-500' />, link: 'https://wa.me/393508616907' },
      { name: 'Phone', ico:<FaPhone className='text-blue-500' />, link: 'tel:393508616907' },
      { name: 'Email', ico:<SiGmail className='text-red-500' />, link: 'mailto:contact@werkeon.com' }
    ];
  
    // Handle service change and update sub-services accordingly
    const handleServiceChange = (e) => {
      setService(e.target.value);
      setSubService(''); // Reset sub-service when service changes
    };
  
    // Proceed to next step if current segment is filled
    const handleNextStep = () => {
      let errors = {};
      if (currentStep === 1) {
        if (!name || !email) {
          errors.name = 'Name and Email are required';
        }
      }
      if (currentStep === 2) {
        if (!date || !time || !service ) {
          errors.date = 'Please fill the required fields';
        }
      }
      if (currentStep === 3) {
        if (!budget || !currency) {
          errors.budget = 'Please provide your budget and currency';
        }
      }
      if (currentStep === 4 && !projectDetails) {
        errors.projectDetails = 'Please provide project details';
      }
  
      if (Object.keys(errors).length > 0) {
        setErrorMessages(errors);
        return;
      }
  
      setErrorMessages({});
      setCurrentStep(currentStep + 1);
    };
  
    // Go back to previous step
    const handleBackStep = () => {
      setCurrentStep(currentStep - 1);
    };
  
    // Reset form fields after submission
    const resetForm = () => {
      setName('');
      setphone('');
      setEmail('');
      setDate(null);
      setTime(null);
      setService('');
      setSubService('');
      setBudget('');
      setCurrency('USD');
      setProjectDetails('');
      setCurrentStep(1);
    };
  
    // Get current date and time for validation
    const now = new Date();
    const minTime = now.getHours() + ':' + now.getMinutes(); // Current time in HH:mm format
  
    // Set max time as 11:59 PM of the same day
    const maxTime = new Date();
    maxTime.setHours(23, 59, 0); // Set max time to 11:59 PM of the same day
  
    const onSubmit = async (event) => {
      event.preventDefault();
  
      // Prepare form data as an object
      const formData = {
        name,
        phone,
        email,
        date,
        time,
        service,
        subService,
        budget,
        currency,
        projectDetails,
        access_key: "8427cf28-0ceb-4be6-82bc-09595066d591" // Add your access key here
      };
  
      const json = JSON.stringify(formData);
  
      // Send the form data to your backend or API
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: json
      }).then((res) => res.json());
  
      if (res.success) {
        Swal.fire({
          title: "Thank you!",
          text: "We are currently reviewing your requirements and will reach out to you as soon as possible.",
          icon: "success"
        });        
        resetForm(); // Reset all form fields
      } 
      else{
        Swal.fire({
          title: "Oops",
          text: "Something went wrong.",
          icon: "error"
        });   
      }
    };

  return (
    <>
      <div className="mx-auto w-full max-w-7xl px-5 py-10">
        
        <div className="flex  gap-8 flex-col md:flex-row md:gap-10 items-center">

          {/* Left or Right Content depending on the index */}
          <div className="max-w-4xl">
            <span className="text-black border-b-2 border-[#E12126] uppercase">Contact Werkeron</span>
            <p className="text-4xl tracking-tighter font-bold  text-balance">
              Get in touch.
            </p>
            <p className="text-regular mt-4 text-gray-700 text-balance">
             Your customers are online   and so are we. At werkeon, we specialize in turning your digital vision into reality. 
             Whether you're looking to elevate your brand with strategic media campaigns, design a high-converting website, or explore new digital opportunities, we're here to help you make it happen. </p>
          <h3 className="text-2xl hidden md:block font-semibold text-gray-700 text-balance my-4 text-left">
            Why Connect With Werkeon🤝?
          </h3>
          <ul className="hidden md:grid gap-4 md:grid-cols-2 text-gray-700 text-base">
            <li>🚀 Expert digital strategy tailored for your industry</li>
            <li>🎯 Creative design and results-driven development</li>
            <li>🤝 Dedicated support from our passionate team</li>
            <li>📈 A long-term partner for your growth</li>
          </ul>
          </div>

          {/* Right or Left Image depending on the index */}
          <div className="h-full hidden md:block w-full">
            <img
              src="../images/contact.png"
              alt="Image"
              className="shadow-box shadow-gray-500/30 overflow-hidden aspect-square w-full h-120 object-contain object-center"
            />
          </div>
        </div>
        <div className='flex flex-col md:flex-row gap-8 lg:gap-10 mt-8'>
      {/* Contact Options Section */}
      <div className='flex  w-full gap-10  lg:px-0'>
        <div className="w-full  mx-auto max-h-[200px] rounded-lg shadow-2xl shadow-gray-400 bg-white">
          <div className="bg-[#175293] w-full p-2 rounded-lg rounded-ee-none rounded-es-none">
            <p className="text-white font-medium text-center uppercase">Get In Touch With Us Now!</p>
          </div>
          <div className="grid grid-cols-3 mt-0 md:mt-4 gap-0 md:gap-10 w-full max-w-5xl items-start justify-start">
            {contactOptions.map((option, index) => (
              <a
                key={index}
                href={option.link}        
                className="flex flex-1 flex-col md:col-span-1 gap-[12.55px] items-center justify-center p-2 md:p-[27.82px] sm:px-5 rounded shadow-bs w-full border-b hover:-translate-y-[1rem] transition-all duration-400"
              >
               <div className="text-3xl">{option.ico}</div>
                {/* <img width="48" height="48" src={option.icon} alt={option.name} /> */}
                <p className="text-left sm:text-[16.25px] md:text-[18.25px] text-[12px] text-gray-900 w-auto font-lato font-semibold">
                  {option.name}
                </p>
              </a>
            ))}

          </div>
        </div>
      </div>

      {/* Form Section */}
      <div className=" md:w-full mx-auto rounded-lg shadow-2xl shadow-gray-400 bg-white">
        <div className="bg-[#175293] w-full p-2 rounded-lg rounded-ee-none rounded-es-none">
          <p className="text-white font-medium text-center uppercase">Get Free Consultation</p>
        </div>
       
        <form onSubmit={onSubmit} className="space-y-6 p-6">
        <div className=' text-center'>
            <p className='text-[12px] md:text-[18px] font-semibold text-black'>Please provide the details below to get started.
            </p>
            <span className='text-[10px] md:text-[14px] text-gray-700'>Believe us, it will take only 30 seconds!</span>
            
            </div>
            <div className="mb-4">
  <p className="text-sm font-semibold text-gray-700 text-center mb-2">
    Step {currentStep} of 3
  </p>
  <div className="w-full bg-gray-200 rounded-full h-2.5">
    <div
      className="bg-[#21AA4A] h-2.5 rounded-full transition-all duration-300 ease-in-out"
      style={{ width: `${(currentStep / 3) * 100}%` }}
    ></div>
  </div>
</div>

        {/* Segment 1: Name, Phone number, and Email */}
        {currentStep === 1 && (
          <div>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              className="mt-1 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="tel"
              id="phone"
              name="phone"
              value={phone}
              onChange={(e) => setphone(e.target.value)}
              placeholder="Enter your contact number (optional)"
              className="mt-4 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="mt-4 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errorMessages.name && <p className="text-red-500 mt-2">{errorMessages.name}</p>}

            <div className="flex justify-between mt-4">
              <button
                type="button"
                className="py-3 px-4 bg-[#21AA4A] text-white w-full font-semibold rounded-lg hover:black focus:outline-none"
                onClick={handleNextStep}
              >
                Next
              </button>
            </div>
          </div>
        )}

        {/* Segment 2: Date, Time, Service, Sub-Service */}
        {currentStep === 2 && (
          <div>
            {/* Date & Time Picker and Service/Sub-Service selection */}
            <div className='flex gap-10'>
              <DatePicker
                selected={date}
                onChange={(date) => setDate(date)}
                placeholderText="Select a date"
                minDate={now} // Prevent selecting past dates
                className="p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <DatePicker
                selected={time}
                onChange={(time) => setTime(time)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                minTime={now} // Set min time to current time
                maxTime={maxTime} // Set max time to 11:59 PM
                timeCaption="Time"
                dateFormat="h:mm aa"
                placeholderText="Select a time"
                className="p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            {/* Service Selection */}
            <select
              id="service"
              name="service"
              value={service}
              onChange={handleServiceChange}
              className="mt-4 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a Service</option>
              <option value="Web development">Web Development</option>
              <option value="Application Development">Application Development</option>
              <option value="Graphic Designing">Graphic Designing</option>
              <option value="Marketing">Marketing</option>
              <option value="Other">Other</option>
            </select>

            {service && (
              <select
                id="subService"
                name="subService"
                value={subService}
                onChange={(e) => setSubService(e.target.value)}
                className="mt-4 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select a Sub-Service</option>
                {subServicesData[service]?.map((sub, index) => (
                  <option key={index} value={sub}>
                    {sub}
                  </option>
                ))}
              </select>
            )}
            {errorMessages.date && <p className="text-red-500 mt-2">{errorMessages.date}</p>}

            <div className="flex gap-5 justify-between mt-4">
              <button
                type="button"
                className="py-3 px-4 bg-gray-600 text-white w-full font-semibold rounded-lg hover:bg-gray-700 focus:outline-none"
                onClick={handleBackStep}
              >
                Back
              </button>
              <button
                type="button"
                className="py-3 px-4 bg-blue-600 text-white w-full font-semibold rounded-lg hover:bg-blue-700 focus:outline-none"
                onClick={handleNextStep}
              >
                Next
              </button>
            </div>
          </div>
        )}

        {/* Segment 3: Budget, Currency, Project Details */}
        {currentStep === 3 && (
          <div>
            <input
              type="number"
              id="budget"
              name="budget"
              value={budget}
              onChange={(e) => setBudget(e.target.value)}
              placeholder="Enter your budget"
              className="mt-1 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <select
              id="currency"
              name="currency"
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              className="mt-4 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
            </select>

            <textarea
              id="projectDetails"
              name="projectDetails"
              rows="4"
              value={projectDetails}
              onChange={(e) => setProjectDetails(e.target.value)}
              placeholder="Enter project details"
              className="mt-4 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errorMessages.budget && <p className="text-red-500 mt-2">{errorMessages.budget}</p>}

            <div className="flex gap-5 justify-between w-full mt-4">
              <button
                type="button"
                className="py-3 px-4 bg-gray-600 text-white font-semibold w-full rounded-lg hover:bg-gray-700 focus:outline-none"
                onClick={handleBackStep}
              >
                Back
              </button>
              <button
                type="submit"
                className="py-3 px-4 bg-blue-600 text-white font-semibold w-full rounded-lg hover:bg-blue-700 focus:outline-none"
              >
                Let's Meet
              </button>
            </div>
          </div>
        )}
      </form>
       
      </div>
      <div className='mx-auto block md:hidden w-full max-w-7xl pb-5'>
       <h3 className="text-2xl block md:hidden font-semibold text-gray-700 text-balance my-4 text-left">
            Why Connect With Werkeon🤝?
          </h3>
          <ul className="grid block md:hidden gap-4 md:grid-cols-2 text-gray-700 text-base">
            <li>🚀 Expert digital strategy tailored for your industry</li>
            <li>🎯 Creative design and results-driven development</li>
            <li>🤝 Dedicated support from our passionate team</li>
            <li>📈 A long-term partner for your growth</li>
          </ul>
      </div>    
     </div>
      </div>
        
    </>
  );
};

export default Contact;
